var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.626 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.348,285a.775.775,0,0,1,.778.778v4.235a.775.775,0,0,1-.778.778H7.307a.8.8,0,0,1-.807-.778v-4.235A.8.8,0,0,1,7.307,285a.775.775,0,0,1,.778.778v3.428H18.57v-3.428A.775.775,0,0,1,19.348,285Z",
    transform: "translate(0 -276.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.656,9.967,106.488,6.8A.774.774,0,0,1,107.582,5.7l1.844,1.815V.778a.778.778,0,1,1,1.556,0V7.519L112.8,5.7a.783.783,0,0,1,1.123,0,.749.749,0,0,1,0,1.095l-3.169,3.169a.765.765,0,0,1-1.095,0Z",
    transform: "translate(-96.876)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.549090b1.svg";
export { ForwardRef as ReactComponent };